import React, { useState } from 'react';
import { Node, Taxonomy } from '@uncinc/react-drupal-core';
import { SliderRelated } from '@uncinc/uncinc-react-kitchen-sink';
import { OverviewIntro, SliderArrow, WysiwygField } from '../../components';
import useValueForCurrentViewPort from '../../helpers/useValueForCurrentViewport';

import './style.scss';

const PillarOverviewSlider = ({ onLoadMore, pager, loading, entities, className, type = 'node', title, subTitle, body, url, introType = 'normal', ...props }) => {
  // This state is used to tell the previous button in the slider
  // to appear whenever the next arrow has been pressed once.
  const [sliderMoved, setSliderMoved] = useState(false);
  // This is used to render either a desktop or a mobile variant,
  // as we don't want to render stuff twice for performance.
  const showDesktop = useValueForCurrentViewPort(false, false, true, true, true);

  return (
    <div className={`View PillarOverviewSlider ${className || ''}`}>
      {showDesktop && entities.size > 2 && (
        <SliderRelated
          accessibility
          autoplay={false}
          autoplaySpeed={7000}
          centerMode={false}
          centerPadding={0}
          nextArrow={<SliderArrow type="next" />}
          pauseOnFocus
          prevArrow={<SliderArrow visible={sliderMoved} type="prev" />}
          slidesToShow={3}
          easing="cubic-bezier(.1,0,.2,1)"
          speed={333}
          infinite
          title={null}
          draggable={false}
          afterChange={() => { setSliderMoved(true); }}
          touchMove
        >
          <div className="PillarOverviewSlider__item-wrapper">
            <OverviewIntro type={introType} title={title} subTitle={subTitle} link={url}>
              <h2>{title}</h2>
              {body && (
                <WysiwygField
                  property="schema:text"
                  className="ViewIntro__body"
                  html={body}
                />
              )}
            </OverviewIntro>
          </div>
          {entities.map((entity, index) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const classNameItemWrapper = 'PillarOverviewSlider__item-wrapper';

            // The type is dependent on the items being rendered, this is node by default,
            // But for themes this is a Taxonomy.
            return (
              <div key={`${uuid}:${langcode}`} className={classNameItemWrapper}>
                {type === 'node' ? (
                  <Node
                    id={id}
                    isActivePath
                    entity={entity}
                    viewMode="teaser"
                  />
                ) : (
                  <Taxonomy
                    id={id}
                    isActivePath
                    entity={entity}
                    viewMode="teaser"
                  />
                )}
              </div>
            );
          })}
        </SliderRelated>
      )}
      {/* Render this if there are less than 2 items in the slider AND showDesktop is true, or if showDesktop is false. ( see L10. )  */}
      {(showDesktop && entities.size <= 2) || !showDesktop ? (
        <div className="row no-gutters">
          <div className="col-12 col-md-4 PillarOverviewSlider__item-wrapper">
            <OverviewIntro title={title} subTitle={subTitle} link={url}>
              <h2>{title}</h2>
              <WysiwygField
                property="schema:text"
                className="ViewIntro__body"
                html={body}
              />
            </OverviewIntro>
          </div>
          {entities.map((entity, index) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const classNameWrapper = 'col-12 col-md-4 PillarOverviewSlider__item-wrapper';

            // As a failsafe and for mobile, we stop rendering items after 2, as we only want 3 items to be shown.
            if (index >= 2) {
              return;
            }

            // The type is dependent on the items being rendered, this is node by default,
            // But for themes this is a Taxonomy.
            return (
              <div key={`${uuid}:${langcode}`} className={classNameWrapper}>
                {type === 'node' ? (
                  <Node
                    id={id}
                    isActivePath
                    entity={entity}
                    viewMode="teaser"
                  />
                ) : (
                  <Taxonomy
                    id={id}
                    isActivePath
                    entity={entity}
                    viewMode="teaser"
                  />
                )}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default PillarOverviewSlider;
